/**
 * How far into the call something happened, as "+4s".
 *
 * The shape of the report users actually give is "the mic switched a few
 * seconds in", not "the mic switched at 11:53:29" — so the elapsed offset sits
 * next to the wall clock rather than replacing it.
 *
 * Returns null when there is nothing to measure from, or when either timestamp
 * cannot be parsed: no anchor means no honest offset.
 */
export const formatRelativeLabel = (
  timestamp: string | null | undefined,
  startTime: string | null | undefined
): string | null => {
  if (!timestamp || !startTime) {
    return null;
  }

  const relativeMs =
    new Date(timestamp).getTime() - new Date(startTime).getTime();

  if (Number.isNaN(relativeMs)) {
    return null;
  }

  return relativeMs < 0
    ? `-${Math.abs(Math.round(relativeMs / 1000))}s`
    : `+${Math.round(relativeMs / 1000)}s`;
};
